import { useCallback, useMemo } from "react";

const defaultFormatter = (name, id) => `[#${id}] ${name}`

function useOptionsParser({ labelKey = "name", valueKey = 'id', formatter = defaultFormatter } = {}) {
  return useCallback((items = []) => items.map(({ [valueKey]: value, [labelKey]: label }) => ({
    value,
    label: formatter(label, value),
  })), [labelKey, valueKey, formatter])
}

export function useFilterOptionsSelect({ useLoad, items }, { params, parserOptions } = {}) {
  useLoad(params)
  const optionsParser = useOptionsParser(parserOptions)
  return useMemo(() => optionsParser(items), [items, optionsParser])
}

export function useFilterOptionsSelectAsync({ list }, params, options) {
  const optionsParser = useOptionsParser(options)
  return useCallback(async term => {
    const data = await list({ term, ...params })
    return {
      options: optionsParser(data),
    }
  }, [list, optionsParser, params])
}
